import router from './router'
import store from './store'
// import { Message } from 'element-ui'
import storage from '@/utils/storage'

import { constantRoutes } from '@/router/modules/allRoutes';

// 白名单通过路由表自动生成，不再自己配置
// const whiteList = ['/login' , '/talent', '/recruitment', '/teamInfoColect']
const whiteList = constantRoutes.map(item => item.path);

router.beforeEach(async (to, from, next) => {
  // console.log(to, from)
  const hasToken = storage.get('loginToken')
  // console.log(hasToken)
  // console.log(to.path)
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/home/index' })
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        next()
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          const roles = await store.dispatch('getInfo')
          // console.log(roles, '-----------')
          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch('generateRoutes', roles)
          // dynamically add accessible routes
          router.addRoutes(accessRoutes)
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true })
        } catch (error) {
          // remove token and go to login page to re-login
          storage.set('token', '')
          // Message.error(error || 'Has Error')
          next(`/login?redirect=${to.path}`)
        }
      }
    }
  } else {
    // console.log(123)
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
    // tempApi pages that do not have permission to access are redirected to the login page.
      next('/login')
    }
  }
})
